<ng-container [ngSwitch]="layout()">
  <ng-container *ngIf="product$ | async as product">
    <ng-container *ngIf="deviceType$ | async as deviceType">
      <ng-container *ngIf="layout() && layout() !== 'tooltip' && layout() !== '6'; else tooltipOrLayoutSix">
        <ng-template [ngSwitchCase]="'1'" [ngSwitchDefault]>
          <div class="dotcms-tile-container">
            <div *ngIf="!product.failed" class="product-tile" [attr.data-testing-sku]="product.sku">
              <div class="product-image-container icsa-image-container">
                <div
                  *ngFor="let view of getImagesViews(product); let i = index"
                  class="{{ i === 0 ? 'primary-image' : 'secondary-image' }} product-img-wrapp"
                >
                  <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                </div>
                <ish-product-label />
                <!-- DIAS Customization - Marketing Bug -->
                <custom-product-marketing-label />
              </div>

              <div class="product-tile-home">
                <span class="product-tile-name">
                  <ish-product-name />
                </span>
                <span class="float-right product-tile-buttons">
                  <ng-container *ishFeature="'orderTemplates'">
                    <ish-lazy-product-add-to-order-template [cssClass]="'btn btn-link mr-0'" displayType="icon" />
                  </ng-container>
                  <ng-container *ishFeature="'wishlists'">
                    <ish-lazy-product-add-to-wishlist cssClass="btn-link" displayType="icon" />
                  </ng-container>
                  <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
                  <div
                    *ishFeature="'quickView'"
                    (click)="openQuickView(product.sku)"
                    (keydown)="openQuickView(product.sku)"
                  >
                    <div>
                      <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                      <button
                        class="btn add-to-compare rounded-circle btn-link"
                        title="{{ 'product.quick_view.link' | translate }}"
                      >
                        <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                        <i class="icon-eye"></i>
                      </button>
                    </div>
                  </div>
                </span>
              </div>

              <div class="position-relative pt-1 pb-3 overflow-hidden">
                <div *ngIf="configuration$('price') | async" class="price-container">
                  <ish-product-price [showInformationalPrice]="true" />
                </div>
                <ish-product-add-to-basket displayType="plaintext" cssClass="add-to-cart btn-link" />
              </div>

              <ng-container *ngIf="variationCount$ | async as variationCount">
                <span class="product-variation read-only"
                  >{{ variationCount }} {{ 'product.variations.text' | translate }}</span
                >
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="'2'">
          <div *ngIf="!product.failed" [attr.data-testing-sku]="product.sku" class="product-grid">
            <div>
              <div class="product-image-container">
                <ish-product-label />
                <!-- DIAS Customization - Marketing Bug -->
                <custom-product-marketing-label />
                <div
                  *ngFor="let view of getImagesViews(product); let i = index"
                  class="{{ i === 0 ? 'first-image' : 'second-image' }} "
                >
                  <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                </div>
              </div>
              <ul class="product-links">
                <li *ishFeature="'orderTemplates'">
                  <ish-lazy-product-add-to-order-template [cssClass]="'btn btn-link mr-0'" displayType="icon" />
                </li>
                <!-- <li>
                  <ish-product-add-to-basket [cssClass]="'btn btn-link mr-0'" displayType="icon"> </ish-product-add-to-basket>
                </li> -->
                <li *ishFeature="'wishlists'">
                  <ish-lazy-product-add-to-wishlist displayType="icon" [cssClass]="'btn btn-link mr-0'" />
                </li>
                <li>
                  <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
                </li>
                <li
                  *ishFeature="'quickView'"
                  (click)="openQuickView(product.sku)"
                  (keydown)="openQuickView(product.sku)"
                >
                  <div>
                    <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                    <button
                      class="btn add-to-compare rounded-circle btn-link"
                      title="{{ 'product.quick_view.link' | translate }}"
                    >
                      <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                      <i class="icon-eye"></i>
                    </button>
                  </div>
                </li>
              </ul>
              <div class="add-to-cart-btn position-relative">
                <ish-product-add-to-basket displayType="plaintext" [cssClass]="''" />
              </div>

              <div class="product-content">
                <h3 class="pro-title"><ish-product-name /></h3>
                <div *ngIf="configuration$('price') | async" class="price-container">
                  <ish-product-price [showInformationalPrice]="true" />
                </div>
              </div>
              <ng-container *ngIf="variationCount$ | async as variationCount">
                <span class="product-variation read-only"
                  >{{ variationCount }} {{ 'product.variations.text' | translate }}</span
                >
              </ng-container>
            </div>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="'3'">
          <div *ngIf="!product.failed" class="product-tile" [attr.data-testing-sku]="product.sku">
            <div class="pro-carosual-three">
              <div class="pro-carosual-three-top">
                <div class="pro-carosual-three-category-name">
                  <div [ngClass]="{ 'category-name-marquee': product?.defaultCategory?.name?.length > 20 }">
                    {{ product?.defaultCategory?.name }}
                  </div>
                </div>
              </div>

              <div class="pro-carosual-three-image-wrapper position-relative">
                <ul class="product-links position-absolute">
                  <li *ishFeature="'orderTemplates'">
                    <ish-lazy-product-add-to-order-template [cssClass]="'btn btn-link mr-0'" displayType="icon" />
                  </li>
                  <!-- <li>
              <ish-product-add-to-basket [cssClass]="'btn btn-link mr-0'" displayType="icon"> </ish-product-add-to-basket>
            </li> -->
                  <li *ishFeature="'wishlists'">
                    <ish-lazy-product-add-to-wishlist displayType="icon" [cssClass]="'btn btn-link mr-0'" />
                  </li>
                  <li>
                    <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
                  </li>
                  <li
                    *ishFeature="'quickView'"
                    (click)="openQuickView(product.sku)"
                    (keydown)="openQuickView(product.sku)"
                  >
                    <div>
                      <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                      <button
                        class="btn add-to-compare rounded-circle btn-link"
                        title="{{ 'product.quick_view.link' | translate }}"
                      >
                        <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                        <i class="icon-eye"></i>
                      </button>
                    </div>
                  </li>
                </ul>

                <div class="product-image-container">
                  <div
                    *ngFor="let view of getImagesViews(product); let i = index"
                    class="{{ i === 0 ? 'first-image' : 'second-image' }} "
                  >
                    <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                  </div>

                  <ish-product-label />
                  <!-- DIAS Customization - Marketing Bug -->
                  <custom-product-marketing-label />
                </div>
              </div>
              <div class="pro-carosual-three-details">
                <div class="pro-carosual-three-title text-center mb-2">
                  <h3 class="pro-title"><ish-product-name /></h3>
                </div>
                <div class="pro-carosual-three-price-tag" *ngIf="configuration$('price') | async">
                  <ish-product-price [showInformationalPrice]="true" />
                </div>
                <div class="pro-carosual-three-details-text">
                  <p [ishServerHtml]="product.shortDescription"></p>
                </div>
                <div class="pro-carosual-three-product-variation">
                  <ng-container *ngIf="variationCount$ | async as variationCount">
                    <span class="product-variation read-only text-center"
                      >{{ variationCount }} {{ 'product.variations.text' | translate }}</span
                    >
                  </ng-container>
                </div>

                <div class="pro-carosual-three-details-btn">
                  <ish-product-add-to-basket displayType="plaintext" cssClass="btn-link" />
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="'4'">
          <div *ngIf="!product.failed" [attr.data-testing-sku]="product.sku" class="product-container">
            <div class="product-layout-four">
              <div class="image-container product-image-container">
                <ish-product-label />
                <!-- DIAS Customization - Marketing Bug -->
                <custom-product-marketing-label />

                <div class="focus-container">
                  <div
                    *ngFor="let view of getImagesViews(product); let i = index"
                    class="{{ i === 0 ? 'original-image' : 'overlay-image' }} "
                  >
                    <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                  </div>
                </div>
                <div class="slide-button">
                  <ng-container *ishFeature="'orderTemplates'">
                    <ish-lazy-product-add-to-order-template [cssClass]="'btn-link'" displayType="icon" />
                  </ng-container>
                  <ng-container *ishFeature="'wishlists'">
                    <ish-lazy-product-add-to-wishlist cssClass="btn-link" displayType="icon" />
                  </ng-container>
                  <div>
                    <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
                  </div>
                  <div
                    *ishFeature="'quickView'"
                    (click)="openQuickView(product.sku)"
                    (keydown)="openQuickView(product.sku)"
                  >
                    <div>
                      <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                      <button
                        class="btn add-to-compare rounded-circle btn-link"
                        title="{{ 'product.quick_view.link' | translate }}"
                      >
                        <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                        <i class="icon-eye"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="button-container">
                  <div class="button-one">
                    <ish-product-add-to-basket displayType="icon" cssClass="btn-link" />
                  </div>
                </div>
              </div>
              <div class="info-container">
                <h3 class="product-name"><ish-product-name /></h3>
                <div class="product-price pro-carosual-four-price-tag" *ngIf="configuration$('price') | async">
                  <ish-product-price [showInformationalPrice]="true" />
                </div>
                <div class="pro-carosual-four-pro-variation">
                  <ng-container *ngIf="variationCount$ | async as variationCount">
                    <span class="read-only">{{ variationCount }} {{ 'product.variations.text' | translate }}</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template [ngSwitchCase]="'5'">
          <div *ngIf="!product.failed" [attr.data-testing-sku]="product.sku" class="product-container">
            <div class="product-layout-five">
              <div class="layout-five-container">
                <div class="row align-items-center">
                  <div class="col-4 pr-2 pl-2">
                    <div class="focus-container">
                      <div
                        *ngFor="let view of getImagesViews(product); let i = index"
                        class="{{ i === 0 ? 'original-image' : 'overlay-image' }} "
                      >
                        <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                      </div>
                    </div>
                  </div>

                  <div class="col-7 pl-0">
                    <div class="info-product-five text-left">
                      <div class="pro-carosual-five-category-name">{{ product?.defaultCategory?.name }}</div>

                      <div class="product-discount-label-five">
                        <div class="product-image-container">
                          <ish-product-label />
                          <!-- DIAS Customization - Marketing Bug -->
                          <custom-product-marketing-label />
                        </div>
                      </div>
                      <h3 class="product-name"><ish-product-name /></h3>
                      <div class="product-price pro-carosual-five-price-tag" *ngIf="configuration$('price') | async">
                        <ish-product-price [showInformationalPrice]="true" />
                      </div>
                      <div class="pro-carosual-five-pro-variation">
                        <ng-container *ngIf="variationCount$ | async as variationCount">
                          <span class="read-only"
                            >{{ variationCount }} {{ 'product.variations.text' | translate }}</span
                          >
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="product-five-icons-container">
                  <ul class="slide-button">
                    <li *ishFeature="'orderTemplates'">
                      <ish-lazy-product-add-to-order-template [cssClass]="'btn-link'" displayType="icon" />
                    </li>

                    <li>
                      <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
                    </li>
                    <li *ishFeature="'wishlists'">
                      <ish-lazy-product-add-to-wishlist cssClass="btn-link" displayType="icon" />
                    </li>
                    <li
                      *ishFeature="'quickView'"
                      (click)="openQuickView(product.sku)"
                      (keydown)="openQuickView(product.sku)"
                    >
                      <div>
                        <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                        <button
                          class="btn add-to-compare rounded-circle btn-link"
                          title="{{ 'product.quick_view.link' | translate }}"
                        >
                          <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                          <i class="icon-eye"></i>
                        </button>
                      </div>
                    </li>
                  </ul>

                  <div class="prod-five-button-add-to-cart">
                    <ish-product-add-to-basket displayType="icon" cssClass="btn-link" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #tooltipOrLayoutSix [ngSwitchDefault]>
        <div
          *ngIf="!product.failed"
          [attr.data-testing-sku]="product.sku"
          class="product-container-six"
          [ngClass]="{ 'layout-six-margin': layout() === '6' }"
        >
          <div class="product-layout-six">
            <div class="image-container product-image-container">
              <ish-product-label />
              <!-- DIAS Customization - Marketing Bug -->
              <custom-product-marketing-label />

              <div class="focus-container">
                <div
                  *ngFor="let view of getImagesViews(product); let i = index"
                  class="{{ i === 0 ? 'original-image' : 'overlay-image' }} "
                >
                  <ish-product-image imageType="M" [imageView]="view" [link]="true" />
                </div>
              </div>
            </div>
            <div class="slide-button">
              <ng-container *ishFeature="'orderTemplates'">
                <ish-lazy-product-add-to-order-template [cssClass]="'btn-link'" displayType="icon" />
              </ng-container>
              <ng-container *ishFeature="'wishlists'">
                <ish-lazy-product-add-to-wishlist cssClass="btn-link" displayType="icon" />
              </ng-container>
              <div>
                <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link" />
              </div>
              <div
                *ishFeature="'quickView'"
                (click)="openQuickView(product.sku)"
                (keydown)="openQuickView(product.sku)"
              >
                <div>
                  <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                  <button
                    class="btn add-to-compare rounded-circle btn-link"
                    title="{{ 'product.quick_view.link' | translate }}"
                  >
                    <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
                    <i class="icon-eye"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="info-container">
              <h3 class="product-name"><ish-product-name /></h3>
              <ish-lazy-product-rating [hideNumberOfReviews]="true" />
              <div class="product-price pro-carosual-four-price-tag" *ngIf="configuration$('price') | async">
                <ish-product-price [showInformationalPrice]="true" />
              </div>
              <div class="pro-carosual-four-pro-variation">
                <ng-container *ngIf="variationCount$ | async as variationCount">
                  <span class="read-only">{{ variationCount }} {{ 'product.variations.text' | translate }}</span>
                </ng-container>
              </div>
              <div class="button-container">
                <div class="button-one">
                  <div>
                    <ish-product-add-to-basket [displayType]="'link'" cssClass="btn-link" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
